import { Box, CssBaseline } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Navbar from "./Navbar.jsx";
import Sidebar from "./Sidebar.jsx";

const Layout = ({ children, onLogout, onNavigate }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { i18n } = useTranslation();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  if (!isAuthenticated) {
    return (
      <Box>
        <CssBaseline />
        {children}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Navbar
        onMenuClick={handleSidebarToggle}
        isSidebarOpen={sidebarOpen}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />
      <Sidebar
        open={sidebarOpen}
        onClose={handleSidebarClose}
        onNavigate={onNavigate}
        onLogout={onLogout}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          width: { sm: `calc(100% - 240px)` },
          mt: 6, // Reduced from 8 to 6 for smaller gap
          direction: i18n.language === "ar" ? "rtl" : "ltr",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
